import Axios from 'axios';
import {urlAPIAgaric} from "../config/Globals";

function find(id){
    return Axios
        .get(urlAPIAgaric+"communes/"+id)
        .then(response => response.data);
}

function search(txt){
    return Axios
        .get(urlAPIAgaric+"communes?search="+txt+"&offset=0&limit=10")
        .then(response => response.data);
}


export default {
    find, search
}